import { render } from "./UpdatePass.vue?vue&type=template&id=a5d8f374&scoped=true"
import script from "./UpdatePass.vue?vue&type=script&lang=js"
export * from "./UpdatePass.vue?vue&type=script&lang=js"

import "./UpdatePass.vue?vue&type=style&index=0&id=a5d8f374&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-a5d8f374"

export default script